import React from 'react';
export function PartnershipsSection() {
  const partners = ['Charles Schwab', 'TD Ameritrade', 'American Express', 'SAP', 'Citi', 'Hilton', 'BMW', 'Audi', 'Anheuser-Busch'];
  return <section className="py-20 bg-navy-900 border-y border-navy-700 overflow-hidden" data-id="element-236">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237">
        <div className="text-center mb-12" data-id="element-238">
          <h2 className="text-sm font-bold tracking-widest text-gold/60 uppercase" data-id="element-239">
            Enterprise Partnerships Structured
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center justify-center opacity-70" data-id="element-240">
          {partners.map((partner, index) => <div key={index} className="flex items-center justify-center p-4 opacity-60 hover:opacity-100 transition-all duration-300" data-id="element-241">
              <span className="text-xl md:text-2xl font-bold text-white/70 text-center tracking-tight" data-id="element-242">
                {partner}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}